import { C } from "@/brand/tokens";
import { SiteHeader5 } from "@/components/layout/SiteHeader5";
import { SiteFooter } from "@/components/layout/SiteFooter";
import {
  HeroSection5,
  ProofBandSection5,
  PatternsSection5,
  ApproachSection5,
  PathwaysSection5,
  TrustSection5,
  InsightsSection5,
  ProcessSection5,
  ConsultationSection5,
} from "@/components/sections5";

/**
 * Concept 5 — Faith 1st final production website.
 *
 * IA re-sequenced around the buyer's decision path:
 *   opening ▸ proof ▸ problem ▸ approach ▸ services ▸ founder
 *   ▸ thought leadership ▸ process ▸ qualified CTA
 *
 * Surface rhythm (warm-dominant, one dark accent chamber at each end):
 *   Hero            Deep Mineral Blue     opening anchor
 *   Proof Band      Dry Stone             compact trust strip
 *   Patterns        Dry Stone             problem recognition
 *   Approach        Soft Parchment        Faith 1st method
 *   Pathways        Dry Stone             four consulting services
 *   Trust           Soft Parchment        founder authority
 *   Insights        Dry Stone             publications
 *   Process         Dry Stone             path to engagement
 *   Consultation    Deep Mineral Blue     closing form
 *   Footer          Smoked Ink
 */
export default function ConceptE() {
  return (
    <main
      data-testid="concept-e"
      className="min-h-screen"
      style={{
        background: C.surfaceLight,
        color: C.textOnLight,
        fontFamily: "Inter, sans-serif",
      }}
    >
      <SiteHeader5 />

      <HeroSection5 />
      <ProofBandSection5 />
      <PatternsSection5 />
      <ApproachSection5 />
      <PathwaysSection5 />
      <TrustSection5 />
      <InsightsSection5 />
      <ProcessSection5 />
      <ConsultationSection5 />

      <SiteFooter
        stamp="Concept 05"
        labelSuffix="Final Production"
        markSubtitle="Leadership, People & Culture"
        descriptor="Faith 1st is a Leadership, People & Culture Consulting firm helping mission-driven and values-led organizations navigate high-stakes people moments through consulting, training, coaching, and facilitation."
      />
    </main>
  );
}
